import { create } from 'zustand';
import { STATIC_SNAPSHOT } from '../../staticSnapshot'; // auto-generated by your script
const useDataStore = create((set) => ({
    data: { ...STATIC_SNAPSHOT },
    firstFetchIsReady: true,
    setData: (path, fetchedData, isProductPage, isBlogPage) => {
        set((state) => {
            const next = { ...fetchedData, isProductPage, isBlogPage };
            const current = state.data[path];
            // The store starts already full, from the static snapshot, and the daily
            // job keeps that snapshot current -- so nearly every live response is
            // identical to what is sitting here. Writing it anyway produced a fresh
            // `data` object, and the nine components that subscribe to `data` as a
            // whole re-rendered for each one. SEOSection is the expensive case: it
            // regenerates the entire SEO document and runs it through DOMPurify on
            // every `data` change.
            //
            // zustand guards its listener notification on Object.is, so returning
            // `state` untouched is a real no-op: no new object, no subscriber wakes
            // up. A response that genuinely differs still falls through and
            // propagates exactly as before.
            if (current && JSON.stringify(current) === JSON.stringify(next)) {
                return state;
            }
            return {
                data: {
                    ...state.data,
                    [path]: next,
                },
            };
        });
    },
    setFirstFetch: (firstFetchIsReady) => {
        set(() => ({ firstFetchIsReady }));
    },
}));
export default useDataStore;
